var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-banner-wrapper prod-skeleton-animate"},[_c('div',{staticClass:"banner prod-skeleton-block"})])}]

export { render, staticRenderFns }